<template>
  <CardSection sectionCaption="My Organization"> 
    <template #content>
      <MyOrganization v-if="organization" 
                      :organization="organization"
                      @refreshOrganization="emit('refreshOrganization')" />
    </template>
  </CardSection>
</template>
<script setup>
// ===============================
// IMPORTS
// ===============================
// Vue Core

// Components
import CardSection from '@/components/common/CardSection.vue';
import MyOrganization from '../organization/MyOrganization.vue';

// Composables

// Stores

// Constants and Utils

// ===============================
// PROPS & EMITS
// ===============================
defineProps({
  organization: {
    type: [Object, null],
    required: true
  }
});

const emit = defineEmits(['refreshOrganization']);

// ===============================
// COMPOSABLES & STORES
// ===============================

// ===============================
// REACTIVE STATE
// ===============================

// ===============================
// CONSTANTS
// ===============================

// ===============================
// COMPUTED PROPERTIES
// ===============================

// ===============================
// METHODS
// ===============================

// ===============================
// WATCHERS
// ===============================

// ===============================
// LIFECYCLE HOOKS
// ===============================

// ===============================
// EXPOSE
// ===============================

</script>

<style scoped>

</style>